import * as React from 'react';
import { styled } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';

const StyDialog = styled(Dialog)({
    minHeight: '80vh',
    minWidth: '80vh',
});

type Props = {
    open: boolean;
    onClose: () => void;
    children?: React.ReactNode;
};

const DashboardsModalWrapper = ({
    open,
    onClose,
    children,
}: Props): JSX.Element => (
    <ErrorBoundary>
        {open ? (
            <StyDialog
                open={open}
                onClose={onClose}
                fullWidth
                className="e2e-library-modal"
            >
                {children}
            </StyDialog>
        ) : null}
    </ErrorBoundary>
);

export default DashboardsModalWrapper;
